import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-prod-sizes',
  templateUrl: './prod-sizes.component.html',
  styleUrls: ['./prod-sizes.component.css']
})
export class ProdSizesComponent implements OnInit {
    prodId;

    public setting?: Setting;

    public itemsListProductSizes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(2168, { prod_id: this.prodId }))[0];
        }
    }

    private async loadProductSizes() {
        if (!!this.setting) {
            this.itemsListProductSizes = await this.datatask.Post(2169, { prod_id: this.setting.prod_id });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadProductSizes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    prod_id: string;
    searchtext: string;
}
